export default __webpack_public_path__ + "static/media/closet4-1024w.3b025908.avif";